import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { SocialProofBar } from '../components/SocialProofBar';
const ProblemSection = lazy(() => import('../components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('../components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const WhatYouGet = lazy(() => import('../components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const UrgencySection = lazy(() => import('../components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const AdaptacionesSection = lazy(() => import('../components/AdaptacionesSection').then(m => ({
  default: m.AdaptacionesSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const CostComparisonSection = lazy(() => import('../components/CostComparisonSection').then(m => ({
  default: m.CostComparisonSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FinalCTA = lazy(() => import('../components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-black" data-id="element-523">
      <div data-id="element-524">
        <HeroSection data-id="element-525" />
        <SocialProofBar data-id="element-526" />

        <Suspense fallback={null} data-id="element-527">
          <ProblemSection data-id="element-528" />
          <SolutionSection data-id="element-529" />
          <WhatYouGet data-id="element-530" />
          <BonusSection data-id="element-531" />
          <UrgencySection data-id="element-532" />
          <PricingSection data-id="element-533" />
          <AdaptacionesSection data-id="element-534" />
          <TestimonialsSection data-id="element-535" />
          <GuaranteeSection data-id="element-536" />
          <CostComparisonSection data-id="element-537" />
          <FAQSection data-id="element-538" />
          <FinalCTA data-id="element-539" />
          <Footer data-id="element-540" />
          <SocialProofPopup data-id="element-541" />
        </Suspense>
      </div>
    </main>;
}